import React, { useEffect, useState } from 'react';
const BASE = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-';
const COLOR_IMAGES = [{
  name: 'Dark Bronze',
  src: `${BASE}DDB.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'Black',
  src: `${BASE}DBK.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'Gold Speck',
  src: `${BASE}DGS.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'Postal Grey',
  src: `${BASE}DPG.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'Sandstone',
  src: `${BASE}DSD.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'Silver Speck',
  src: `${BASE}DSS.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'White',
  src: `${BASE}DWH.jpg&h=600&site=6153&user=4145&v=1&w=600`
}, {
  name: 'Antique Bronze',
  src: `${BASE}DAB.jpg&h=600&site=6153&user=4145&v=1&w=600`
}];
interface ProductGalleryProps {
  selectedColor?: string;
}
export function ProductGallery({
  selectedColor
}: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  // Follow the color chosen in the options panel.
  useEffect(() => {
    if (!selectedColor) return;
    const idx = COLOR_IMAGES.findIndex(c => c.name === selectedColor);
    if (idx >= 0) setActiveIndex(idx);
  }, [selectedColor]);
  return <div className="flex flex-col gap-4" data-id="element-687" data-mp="nvjc2rsrcqsa">
      {/* Main Image */}
      <div className="bg-white rounded-xl border border-brand-border aspect-square p-8 flex items-center justify-center relative overflow-hidden" data-id="element-688" data-mp="nvrn0e5blm0u">
        <img src={COLOR_IMAGES[activeIndex].src} alt={`Versatile 4C Depot 16H - 20 Door Package in ${COLOR_IMAGES[activeIndex].name}`} className="w-full h-full object-contain mix-blend-multiply" data-id="element-689" data-mp="xu8inof7eot8" />
      </div>

      {/* Thumbnails */}
      <div className="grid grid-cols-4 gap-3" data-id="element-690" data-mp="29aoyhiuo77gm">
        {COLOR_IMAGES.map((img, idx) => <button key={img.name} type="button" onClick={() => setActiveIndex(idx)} aria-label={`View ${img.name}`} aria-pressed={activeIndex === idx} className={`bg-white rounded-lg border aspect-square p-2 flex items-center justify-center transition-all focus:outline-none focus:ring-2 focus:ring-brand-maroon ${activeIndex === idx ? 'border-brand-maroon ring-1 ring-brand-maroon' : 'border-brand-border hover:border-brand-maroon/50'}`} data-id="element-691" data-mp="24c3ztnv2gvua" data-mpi={idx}>
            <img src={img.src} alt={`${img.name} finish`} className="w-full h-full object-contain mix-blend-multiply" data-id="element-692" data-mp="1xlb5k426c18x" />
          </button>)}
      </div>
    </div>;
}